module.exports = __webpack_public_path__ + "img/icon_03gxbj@2x.b01f0df0.png";